/**
 * Hook pour gerer le changelog et la detection de version non vue.
 * Utilise localStorage par userId pour persister le "vu/pas vu".
 */

import { useState, useCallback } from 'react';
import { CHANGELOG, APP_VERSION } from '@bstock/shared';
import { useAuth } from '@/context/AuthContext';

const STORAGE_PREFIX = 'bstock_changelog_seen_v';

export function useChangelog() {
  const { user } = useAuth();
  const storageKey = `${STORAGE_PREFIX}${user?.id ?? 'anonymous'}`;

  const latestVersion = CHANGELOG[0]?.version ?? APP_VERSION;

  const [lastSeenVersion, setLastSeenVersion] = useState<string | null>(() =>
    localStorage.getItem(storageKey)
  );

  const hasUnseen = lastSeenVersion !== latestVersion;

  const markAsSeen = useCallback(() => {
    localStorage.setItem(storageKey, latestVersion);
    setLastSeenVersion(latestVersion);
  }, [storageKey, latestVersion]);

  return {
    hasUnseen,
    allEntries: CHANGELOG,
    markAsSeen,
    latestVersion,
  };
}
